document.addEventListener('DOMContentLoaded', function () {
const checkboxes = document.querySelectorAll(".order-personalization-checkbox");

  checkboxes.forEach((checkboxe) => {
    checkboxe.addEventListener('change', function () {
      // esconde todos o campo da opção "Outro"
      document.querySelectorAll("[id^='wrapper-other']").forEach((wrapper) => {
        wrapper.style.display = 'none';
        const input = wrapper.querySelector('input');
        if (input) {
          input.required = false;
          input.value = '';
        }
      });

      // se marcou "Outro", mostra o campo da opção
      checkboxes.forEach((cb) => {
        if (cb.value === 'Outro' && cb.checked) {
          const wrapperId = cb.id.replace('option-other', 'wrapper-other');
          const wrapper = document.getElementById(wrapperId);
          if (wrapper) {
            wrapper.style.display = 'block';
            const input = wrapper.querySelector('input');
            if (input) input.required = true;
          }
        }
      });
    });
  });
});
